export default ["gray", "purple", "green", "blue", "cyan"] as const;
